import type { CancelAddOnSubscriptionBody } from '@ctct/infrastructure-layer';
import { myAccountApi } from '@ctct/infrastructure-layer';

import { type AddOnsRequest, AddOnsResponseSchema, CancelAddonServiceSchema } from './schemas';
import { AddOnsVO } from '../../value-objects';
import { zodService } from '../ZodService';

class AddOnsRepo {
  public async getAddOns(body: AddOnsRequest) {
    const response = await myAccountApi.getAddOns(
      body.planGroupId,
      body.planId,
      body.currencyCode,
      body.includePurchased
    );

    const data = zodService.safeParse(AddOnsResponseSchema, response.data);

    const addOnsVO = new AddOnsVO(data);

    return addOnsVO;
  }

  public async cancelAddOnSubscription(body: CancelAddOnSubscriptionBody) {
    const response = await myAccountApi.postCancelAddOnSubscription(body);

    const data = zodService.safeParse(CancelAddonServiceSchema, response.data);

    return data;
  }
}

export const addOnsRepo = new AddOnsRepo();
